import { ApiClient } from "./api.ts";

export class MetricsService {
    private static instance: MetricsService;
    private api = ApiClient.getInstance();

    private constructor() { }

    public static getInstance(): MetricsService {
        if (!MetricsService.instance) {
            MetricsService.instance = new MetricsService();
        }
        return MetricsService.instance;
    }

    /**
     * Fetch a specific named metric for an organization.
     * @param type The type of metric (traffic, latency, error_rate, data_usage, top_routes)
     * @param orgId The organization ID to scope data to
     * @param period The time period for the metric (5m, 30m, 1h, 24h)
     * @returns The JSON response from the secure backend
     */
    async getMetric(type: string, orgId: string, period: string = '5m', start?: number, end?: number, filters?: Record<string, string>, limit?: number, interval?: number): Promise<any> {
        try {
            let path = `/metrics?metric=${type}&organization_id=${orgId}`;
            if (start) {
                path += `&start=${start}`;
                if (end) path += `&end=${end}`;
            } else {
                path += `&period=${period}`;
            }
            if (limit) {
                path += `&limit=${limit}`;
            }
            if (interval) {
                path += `&interval=${interval}`;
            }
            if (filters) {
                if (filters.method) path += `&filter_method=${encodeURIComponent(filters.method)}`;
                if (filters.status) path += `&filter_status=${encodeURIComponent(filters.status)}`;
                if (filters.path) path += `&filter_path=${encodeURIComponent(filters.path)}`;
                if (filters.ip) path += `&filter_ip=${encodeURIComponent(filters.ip)}`;
                if (filters.host) path += `&filter_host=${encodeURIComponent(filters.host)}`;
            }
            return await this.api.request(path);
        } catch (error) {
            console.error('Error fetching metrics:', error);
            return null;
        }
    }
}
